<script type="text/javascript">
  export default {};
</script>

<template>
  <div class="notification-loader">
    <div class="notification-loader__avatar">
      <div class="notification-loader__avatar-circle"></div>
    </div>
    <div class="notification-loader__content">
      <div class="notification-loader__text-1"></div>
      <div class="notification-loader__text-2"></div>
      <div class="notification-loader__text-3"></div>
    </div>
  </div>
</template>

<style lang="scss">
  .notification-loader {
    @import '~styles/settings';

    display: flex;
    align-items: center;
    background: $white;
    height: 80px;
    padding: 0 20px;
    border-bottom: 1px solid $grey2;

    &__avatar {
      width: 25%;

      &-circle {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        background: $blue2;
        opacity: 0.4;
      }
    }

    &__content {
      width: 75%;
    }

    &__text-1 {
      margin: 5px 0;

      @include text-line(100%, 9px);
    }

    &__text-2 {
      margin: 5px 0;

      @include text-line(70%, 9px);
    }
    &__text-3 {
      margin: 5px 0;

      @include text-line(50%, 9px);
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/NotificationLoader.vue